import { computed } from "vue";

const DELAY_MS = 120;

/** 模块级单例，保证 app / plugin 共用同一状态 */
const state = {
	pendingCount: 0,
	visible: false,
	showTimer: null,
};

function clearShowTimer() {
	if (state.showTimer != null) {
		clearTimeout(state.showTimer);
		state.showTimer = null;
	}
}

function syncVisible(visibleRef) {
	if (state.pendingCount > 0) {
		if (state.visible || state.showTimer != null) return;
		state.showTimer = setTimeout(() => {
			state.showTimer = null;
			if (state.pendingCount > 0) {
				state.visible = true;
				visibleRef.value = true;
			}
		}, DELAY_MS);
		return;
	}

	clearShowTimer();
	state.visible = false;
	visibleRef.value = false;
}

export function usePageLoading() {
	const visible = useState("global-page-loading-visible", () => false);

	const start = () => {
		if (!import.meta.client) return;
		state.pendingCount += 1;
		syncVisible(visible);
	};

	const stop = () => {
		if (!import.meta.client) return;
		state.pendingCount = Math.max(0, state.pendingCount - 1);
		syncVisible(visible);
	};

	const forceStop = () => {
		if (!import.meta.client) return;
		state.pendingCount = 0;
		clearShowTimer();
		state.visible = false;
		visible.value = false;
	};

	return {
		isPageLoading: computed(() => visible.value),
		startPageLoading: start,
		stopPageLoading: stop,
		forceStopPageLoading: forceStop,
	};
}
